import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHead } from '../SectionHead';
import { Stage } from './Stage';
import { PartsByArea } from './PartsByArea';
import { Journey } from './Journey';
import { RepairTable } from './RepairTable';
import { HistoryOutlined } from '@ant-design/icons';

export const HistoryOverview = ({ history, state, actions }) => {
    const { t } = useTranslation('reportPage');
    const { journey, selectedZone } = history;
    const filterBits = journey
        ? [
              t('journey.filterLabel', { shown: journey.shownCount, count: journey.total }),
              selectedZone && selectedZone.name,
              state.year,
          ]
        : [];

    return (
        <section id="history" className="card" aria-labelledby="history-title">
            <SectionHead
                id="history-title"
                icon={HistoryOutlined}
                title={t('history.title')}
                sub={history.car && history.car.period}
            />
            {history.aiLine && (
                <div className="ai-line">
                    <span className="aipill">{t('ai.pill')}</span>
                    <p>{history.aiLine}</p>
                </div>
            )}
            <Stage history={history} onZone={actions.toggleZone} onYear={actions.selectYear} />
            <div className="hcols">
                {history.zones.length > 0 && (
                    <PartsByArea zones={history.zones} minor={history.minor} onZone={actions.toggleZone} />
                )}
                <div className="hcol-journey">
                    {journey && (
                        <Journey
                            journey={journey}
                            filterLabel={filterBits.filter(bit => bit != null && bit !== '').join(' · ')}
                            allVisits={state.allVisits}
                            onToggle={actions.toggleVisit}
                            onClearFilter={actions.clearFilters}
                            onToggleAll={actions.toggleAllVisits}
                        />
                    )}
                    {history.repairs && (
                        <RepairTable
                            repairs={history.repairs}
                            allRepairs={state.allRepairs}
                            onToggleAll={actions.toggleAllRepairs}
                            withJourney={!!journey}
                        />
                    )}
                </div>
            </div>
        </section>
    );
};
